<div class="gyan-input">
    <!-- Topic input level -->
    <div class="row gyan-input-row" [ngClass]="{ highlight: isThreeDotsHovered }">
        <div class="col-9 col-sm-9">
            <div class="float-start">
                <input
                    class="article-placeholder"
                    #topicInput
                    type="text"
                    [(ngModel)]="topic.name"
                    (ngModelChange)="sendTopicName()"
                    (keydown)="onKeydown($event)"
                    (input)="sanitizeInput($event)"
                    (blur)="onBlur($event)"
                    (focus)="onFocus()"
                    (paste)="onPaste($event)"
                    [ngStyle]="{ 'margin-left': topic.level * 20 + 'px' }"
                    [placeholder]="topic.level === 0 ? 'What topic would you like to research?' : 'Enter any topic'"
                    [attr.id]="'gyan-' + topic.name"
                    [attr.data-test]="'gyan-' + topic.name"
                />
            </div>
            <!-- Plus icon for adding a new subtopic -->
            <div
                *ngIf="isFocused && topic.name.trim() !== ''"
                class="add-subtopic-icon float-start"
                (mousedown)="onAddIconClick()"
                [ngStyle]="{ 'margin-left': '5px', cursor: 'pointer' }"
            >
                <div
                    class="gyan-topic-plus-icon"
                    [attr.id]="'add-topic-' + generateDataId(topic, pathIndices)"
                    [attr.data-test]="'add-topic-' + generateDataId(topic, pathIndices)"
                ></div>
            </div>
        </div>
        <div class="col-3 col-sm-3">
            <!-- Three dots menu -->
            <div class="position-relative">
                <div
                    *ngIf="topic.name.trim() !== ''"
                    class="float-end menu-dropdown-menu-icon"
                    (click)="toggleMenu($event)"
                    [attr.id]="'topic-option-' + generateDataId(topic, pathIndices)"
                    [attr.data-test]="'topic-option-' + generateDataId(topic, pathIndices)"
                    (mouseenter)="onThreeDotsHover(true)"
                    (mouseleave)="onThreeDotsHover(false)"
                >
                    <fa-icon class="float-end p-1 cursor-pointer" [icon]="faEllipsisV"> </fa-icon>
                </div>

                <div *ngIf="showMenu" #menuDropdown class="menu-dropdown">
                    <div
                        *ngIf="GyanTemplatesPermission"
                        class="menu-dropdown-item"
                        (click)="showPopup('gyanTemplate', topic.id, gyanTemplateContent, 'md')"
                        title="Create Gyan with predefined outlines"
                    >
                        <div class="gyan-templates-icon"></div>
                        Gyan Templates
                    </div>
                    <div
                        *ngIf="KeyConceptsPermission"
                        class="menu-dropdown-item"
                        (click)="showPopup('keyConcept', topic.id, keyConceptContent, 'md')"
                        title="Add keywords to improve search space"
                    >
                        <div
                            class="key-concepts-icon"
                            [attr.id]="'key-concept-' + generateDataId(topic, pathIndices)"
                            [attr.data-test]="'key-concept-' + generateDataId(topic, pathIndices)"
                        ></div>
                        Key Concepts
                    </div>
                    <div
                        *ngIf="TopicLevelSourcingPermission"
                        class="menu-dropdown-item"
                        (click)="showPopup('topicOutlineSources', topic.id, subtopicSourcesContent, 'lg')"
                        title="Add sources"
                    >
                        <div
                            class="topic-outline-sources-icon"
                            [attr.id]="'subtopic-sources-' + generateDataId(topic, pathIndices)"
                            [attr.data-test]="'subtopic-sources-' + generateDataId(topic, pathIndices)"
                        ></div>
                        Sources
                    </div>
                    <div
                        *ngIf="TocSettingsPermission"
                        class="menu-dropdown-item"
                        (click)="showPopup('settings', topic.id, settingsContent, 'sm')"
                        title="More settings to fine tune your search space and results"
                    >
                        <div
                            class="settings-icon"
                            [attr.id]="'settings-' + generateDataId(topic, pathIndices)"
                            [attr.data-test]="'settings-' + generateDataId(topic, pathIndices)"
                        ></div>
                        Settings
                    </div>
                </div>
            </div>
        </div>
        <div class="clear"></div>
    </div>
    <!-- Recursive rendering of subtopics -->
    <div *ngFor="let subtopic of topic.subtopics; let i = index">
        <app-gyan-input
            [topic]="subtopic"
            [parentTopic]="topic"
            [grandParentTopic]="parentTopic"
            (save)="save.emit()"
            (saveKeyConcepts)="saveKeyConcepts.emit($event)"
            (saveTemplates)="saveTemplates.emit($event)"
            (saveSubTopicSources)="saveSubTopicSources.emit($event)"
            (saveSettingsParams)="saveSettingsParams.emit($event)"
            [pathIndices]="(pathIndices || []).concat(i)"
        ></app-gyan-input>
    </div>
</div>

<ng-template #gyanTemplateContent let-modal>
    <app-gyan-templates [topic]="currentTopic" [modal]="modal" (subtopicsUpdated)="onSubtopicsUpdated($event)"></app-gyan-templates>
</ng-template>

<ng-template #keyConceptContent let-modal>
    <app-key-concept [topic]="currentTopic" [modal]="modal" (save)="onSaveKeyConcepts($event)"></app-key-concept>
</ng-template>

<ng-template #subtopicSourcesContent let-modal>
    <app-sub-topic-sources [topic]="currentTopic" [gksLevel]="gksLevel" [modal]="modal" (saveSubTopicSources)="onSaveSubTopicSources($event)"></app-sub-topic-sources>
</ng-template>

<ng-template #settingsContent let-modal>
    <div class="modal-header d-flex">
        <div class="modal-title">Settings</div>
        <div type="button" class="gyan-popup-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <div class="modal-close-icon"></div>
        </div>
    </div>
    <div class="modal-body">
        <app-toc-settings [topic]="currentTopic" (saveSettingsValue)="onSaveSettings($event)"></app-toc-settings>
    </div>
    <!-- <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.close('Close click')">Close</button>
        <button type="button" class="btn btn-primary" (click)="saveFormToLocalStorage(selectedKnowledgeStore.uuid)">Save</button>
    </div> -->
</ng-template>
